function IsOpen(arr) {
  const tDate = new Date();
  const tDay = tDate.getDay();
  const tTime = tDate.getHours() + ':' + tDate.getMinutes();

  const currentDay = arr.find((item, index) => {
    if (index === tDay) {
      return item;
    }
    return false;
  });
  const openTime = minutesOfDay(currentDay.openTime);
  const closeTime = minutesOfDay(currentDay.closeTime);
  const isOpenTime = minutesOfDay(tTime) >= openTime && minutesOfDay(tTime) <= closeTime;

  return isOpenTime;
}

function minutesOfDay(time) {
  let timeArray = time.split(':');
  let hours = parseInt(timeArray[0]);
  let minutes = parseInt(timeArray[1]);

  if (time.indexOf('am') != -1 && hours == 12) {
    hours = 0;
  }
  if (time.indexOf('pm') != -1 && hours < 12) {
    hours = hours + 12;
  }

  return hours * 60 + minutes;
}

function formatDateTime(postDateTime) {
  const postTime = new Date(postDateTime);
  const currentTime = new Date();
  const diffTime = Math.abs(currentTime - postTime);
  let diffDateTime = [
    { second: Math.floor(diffTime / 1000) },
    { minute: Math.floor(diffTime / (1000 * 60)) },
    { hour: Math.floor(diffTime / (1000 * 60 * 60)) },
    { day: Math.floor(diffTime / (1000 * 60 * 60 * 24)) },
    { week: Math.floor(diffTime / (1000 * 60 * 60 * 24 * 7)) },
    { month: Math.floor(diffTime / (1000 * 60 * 60 * 24 * 30)) },
    { year: Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365)) },
  ];

  let resultDateTime = '';
  diffDateTime.reverse().every((ele) => {
    const key = Object.keys(ele)[0];
    const value = Object.values(ele)[0];
    if (value > 0) {
      resultDateTime = `${value} ${key}${value > 1 ? 's' : ''} ago`;
      return false;
    }
    return true;
  });

  return resultDateTime;
}

export { IsOpen, minutesOfDay, formatDateTime };
